import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { NguCarouselConfig } from "@ngu/carousel";
import { MyDatePicker, IMyDpOptions } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { AppService } from '../services/app.service';
import { environment } from '../../environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { SupportService } from '../services/support-service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { HomeSelectionSharedService } from '../services/home-selection-shared.service';

@Component({
  selector: 'app-selection-screen',
  templateUrl: './selection-screen.component.html',
  styleUrls: ['./selection-screen.component.scss'],
})
export class SelectionScreenComponent implements OnInit {
  @ViewChild('anotherProcedure') anotherProcedure: TemplateRef<any>;
  @ViewChild('mydp') mydp: MyDatePicker;
  @ViewChild('mydp1') mydp1: MyDatePicker;

  @ViewChild('examModal') examModal: TemplateRef<any>;
  @ViewChild('bodyPartModal') bodyPartModal: TemplateRef<any>;
  @ViewChild('ProcedureModal') ProcedureModal: TemplateRef<any>;
  @ViewChild('tcListDiv') tcListDiv: TemplateRef<any>;
  isOpen = true;
  scheduleRegion: any = {};
  areas: any = [];
  testcentrebycriteria: any = [];
  scheduledData: any = {};
  insuranceList: any = [];
  allExamList: any = [];
  cptCodeList: any = [];
  path: any;
  scheduleappointmentid: any = '';
  appointData: any = {};
  countryCode: any;
  homeLocation: any;
  homeLocationPlaceholder: any = 'Location';
  homeInsuranceType: any;
  homeInsurance: any;
  selectProcedureList: any = [];
  addProcedureList: any = [];
  placeholerCptCode: any;
  popProcedures: any = [];
  paymode: any;
  selectedlang: any;
  homeinfosubmit = false;
  selectIndex: any = -1;
  countryId: any = 231;
  couldFrontURL = environment.cloudFrontURL;
  lat: number;
  lng: number;
  multiplePro = false;
  homeExamId: any = '';
  homeExamName: any = '';
  homeBodyPartId: any = '';
  homeBodyPartName: any = '';
  homeCptCode: any = '';
  homeProcedureName: any = '';
  currencysymbol = environment.symbol[0];
  editProcedure = false;
  showAddProcedureFormMob = false;
  viewMobProceduresList = false;
  homeinfosubmitNew = false;
  blockAddMultipleProcedure = true;
  showFilters = false;
  timeSlotDisabeld = false;
  cptcodeobject: any;
  showaddProcedure = false;
  date: any;
  patientData: any;
  isMobile = false;
  desktopView = false;
  mobileView = false;
  formatter: any;
  homeInsuranceName: any;
  homeInsuranceTypeName: any;
  @ViewChild('insuranceModal') insuranceModal: TemplateRef<any>;
  @ViewChild('insuranceTypeModal') insuranceTypeModal: TemplateRef<any>;
  timeZone = 0;
  showErrDate = false;
  disabledInsType = false;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  testcenter: any;
  timeslot: any;
  scheduleToTime: any;
  lastProcedureIndx: any;
  bodypartsList: any = [];
  procedureList: any = [];
  cptcodeobjectForMobile: any;
  dayOfweek = '';
  timezone_offset_min: any;
  offset_hrs: any;
  offset_min: any;
  filteron = false;

  public carouselTileItems: Array<any> = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
  ];
  public carouselTiles = {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  };

  public carouselTile: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 5, lg: 5, all: 0 },
    slide: 5,
    speed: 250,
    point: {
      visible: false,
    },
    load: 2,
    velocity: 2,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
  };
  public myDatePickerOptions: IMyDpOptions = {};
  today = new Date();
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  homeDate: any = this.formatHomeDate(this.today);
  homeDatePlaceHolder: any = this.formatHomeDate(this.today);
  city: any;
  viewProcedures = false;
  @ViewChild('confirmationpopup') confirmationpopup: TemplateRef<any>;

  constructor(
    private supportService: SupportService,
    private appservice: AppService,
    private router: Router,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private ngxloader: NgxUiLoaderService,
    private homeSelectionShared: HomeSelectionSharedService
  ) {
    this.currentDate = this.today.getDate() - 1;
    this.currentMonth = this.today.getMonth() + 1;
    this.currentYear = this.today.getFullYear();
    this.myDatePickerOptions = {
      dateFormat: 'mmm dd, yyyy',
      minYear: +this.currentYear,
      firstDayOfWeek: 'su',
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      maxYear: +this.currentYear,
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: false,
      inline: false,
    };
    window.onresize = (e) => {
      this.ngAfterViewInit();
    };
  }

  clearSearch() {
    return this.homeSelectionShared.clearSearch(this);
  }

  gotoTestcenter(tcobj) {
    if (tcobj) {
      const data = {
        scheduleOn: this.scheduledData.scheduleOn,
        cptCodes: this.scheduledData.cptCodeList,
        tcId: tcobj.tcView.testcenterId,
        profile: tcobj.profileImage,
      };
      localStorage.setItem('tcdetail', JSON.stringify(data));
      if (this.scheduleappointmentid) {
        this.router.navigate(['/detail-page', this.scheduleappointmentid]);
      } else {
        this.router.navigate(['/detail-page']);
      }
    }
  }

  ngAfterViewInit() {
    this.onResize(window.innerWidth);
  }

  getallbodypartsbyexamonchange(examid, index) {
    const data = { examId: examid };
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res['status'] && res['status']['status'] === 204) {
          this.toastr.error('Procedure is not available');
          this.selectProcedureList[index].examId = '';
        } else if (res && res['entity']) {
          this.selectProcedureList[index].bodyPartList = res['entity'];
          if (
            this.cptcodeobject &&
            this.selectProcedureList[index].bodyPartList &&
            this.selectProcedureList[index].bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].bodyPartList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].bodyPartList[i].id ===
                this.cptcodeobject['bodyPart']['id']
              ) {
                this.selectProcedureList[index].bodyPartId = this.cptcodeobject[
                  'bodyPart'
                ]['id'];
                this.selectProcedureList[
                  index
                ].bodyPartName = this.cptcodeobject['bodyPart']['bodyPart'];
                this.getallproceduresbybodypartbyonchange(
                  this.selectProcedureList[index].bodyPartList[i].id,
                  index
                );
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallproceduresbybodypartbyonchange(bodypartId, index) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          for (let e = 0; e < res['entity'].length; e++) {
            res['entity'][e].checked = false;
          }
          this.selectProcedureList[index].procedureList = res['entity'];
          this.openpopuptemplateonchanged(
            this.selectProcedureList[index].procedureList,
            this.selectProcedureList[index].cptCode,
            index
          );
          if (
            this.cptcodeobject &&
            this.selectProcedureList[index].procedureList &&
            this.selectProcedureList[index].procedureList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].procedureList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].procedureList[i].id ===
                this.cptcodeobject['id']
              ) {
                this.selectProcedureList[
                  index
                ].procedureName = this.cptcodeobject['procedureName'];
                this.selectProcedureList[index].duration = this.cptcodeobject[
                  'duration'
                ];
                this.selectProcedureList[index].open = false;
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  openpopuptemplateonchanged(procedures, cptcode, ind) {
    return this.homeSelectionShared.openpopuptemplateonchanged(
      this,
      procedures,
      cptcode,
      ind
    );
  }

  getallExamListOnchange(cptcode, index) {
    const data = { cptcode: cptcode };

    this.appservice
      .getallexamdandprocedureandbodypartbycptcodeForhome(data)
      .subscribe((res) => {
        if (res && res['status']['status'] === 200) {
          if (
            res['entity'] &&
            res['entity']['bodyPart'] &&
            res['entity']['bodyPart']['exam']
          ) {
            this.cptcodeobject = res['entity'];
            this.selectProcedureList[index].examId =
              res['entity']['bodyPart']['exam']['id'];
            this.selectProcedureList[index].examName =
              res['entity']['bodyPart']['exam']['examshortname'];
            this.selectProcedureList[index].invalidcptcode = false;
            this.selectProcedureList[index].cptCode = this.cptcodeobject[
              'cptCode'
            ];
            this.selectProcedureList[index].tmpcptcode = this.cptcodeobject[
              'cptCode'
            ];
            this.getallbodypartsbyexamonchange(
              this.selectProcedureList[index].examId,
              index
            );
          }
        } else if (res['status']['status'] === 204) {
          this.toastr.error('Please check your cptcode');
          this.selectProcedureList[index].invalidcptcode = true;
          this.selectProcedureList[index].bodyPartId = '';
          this.selectProcedureList[index].bodyPartName = '';
          this.selectProcedureList[index].procedureName = '';
          this.selectProcedureList[index].procedureList = [];
          this.selectProcedureList[index].examId = '';
        }
      });
  }

  mobileaddnew(type) {
    if (type === 'no') {
      this.showaddProcedure = false;
    } else if (type === 'yes') {
      this.showaddProcedure = true;
    }
  }

  cptcodeChange(value, index) {
    return this.homeSelectionShared.cptcodeChange(this, value, index);
  }

  scrollFunction() {
    let mybutton;
    if (this.isMobile) {
      mybutton = document.getElementById('top-scr`oll-mobile');
    } else {
      mybutton = document.getElementById('top-scroll');
    }

    if (mybutton && mybutton.style) {
      if (
        document.body.scrollTop > 60 ||
        document.documentElement.scrollTop > 60
      ) {
        mybutton.style.display = 'block';
      } else {
        mybutton.style.display = 'none';
      }
    }
  }

  ngDoCheck() {
    const obj = this;
    window.onscroll = function () {
      obj.scrollFunction();
    };
  }

  ngOnInit() {
    if (window.screen.width <= 540) {
      this.isMobile = true;
    }
    this.scrollFunction();
    this.supportService.showback.next(true);
    this.getLanguage();
    this.getallexams();
    this.testcentrebycriteria = [];
    this.path = this.router.url;
    const Splitpath = this.path.split('/');
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
    }
    this.scheduleRegion = [];
    this.testcentrebycriteria = [];
    sessionStorage.getItem('testCenterByCriteria') != null
      ? (this.scheduleRegion = JSON.parse(
        sessionStorage.getItem('testCenterByCriteria')
      ))
      : (this.scheduleRegion = {});
    if (this.scheduleRegion && this.scheduleRegion.schedules) {
      this.testcentrebycriteria = this.scheduleRegion.schedules;

      this.checkDate();
    }
    this.areas = [];
    if (this.scheduleRegion.areas && this.scheduleRegion.areas.length > 0) {
      for (let i = 0; i < this.scheduleRegion.areas.length; i++) {
        this.areas.push({
          areaName: this.scheduleRegion.areas[i],
          checked: true,
        });
      }
    }
    sessionStorage.getItem('scheduleData') != null
      ? (this.scheduledData = JSON.parse(
        sessionStorage.getItem('scheduleData')
      ))
      : (this.scheduledData = {});
    sessionStorage.getItem('patientData') != null
      ? (this.patientData = JSON.parse(sessionStorage.getItem('patientData')))
      : (this.patientData = {});
    if (
      !this.scheduledData ||
      !this.patientData ||
      this.scheduledData === {} ||
      this.patientData === {}
    ) {
      this.router.navigate(['/home']);
    } else {
      this.supportService.patientname.next(this.patientData.firstName);
    }
    this.populateData();
    this.addProcedureList.examId = '';
    this.addProcedureList.bodyPartId = '';
    this.addProcedureList.bodyPartName = '';
    this.addProcedureList.cptCode = '';
    this.addProcedureList.procedureName = '';
    this.addProcedureList.procedureId = '';
    this.addProcedureList.procedureList = [];
    this.addProcedureList.procedureSelected = '';
    this.scheduleFormSubmit('final');
  }

  onResize(innerWidth) {
    if (innerWidth < 1025) {
      // Mobile
      this.desktopView = false;
      this.mobileView = true;
    } else {
      // desktop
      this.desktopView = true;
      this.mobileView = false;
    }
  }

  selectAddress() {
    const ele = document.querySelectorAll('.pac-container');
    if (ele.length > 0) {
      ele.forEach((element, index) => {
        ele[index].setAttribute(
          'class',
          'pac-container pac-logo hdpi selection-screen-top'
        );
      });
    }
  }

  showProcedures() {
    this.timeSlotDisabeld = false;
    this.viewProcedures = true;
  }

  hideProcedures() {
    this.viewProcedures = false;
  }

  triggerDatePicker() {
    document.getElementById('sspageDatePick').click();
  }

  convertkmstomile(kilometers) {
    return (kilometers / 1.6);
  }

  populateData() {
    if (this.scheduledData) {
      this.homeDate = this.formatHomeDateStr(this.scheduledData.scheduleOn);
      this.homeDatePlaceHolder = this.formatHomeDateStr(
        this.scheduledData.scheduleOn
      );
      this.homeLocation = this.scheduledData.location;
      this.homeLocationPlaceholder = 'Location';
      this.paymode = this.scheduledData.payMode;
      this.countryCode = this.scheduledData.countryCode;
      localStorage.setItem('countryCodeNew', this.countryCode);
      this.currencysymbol =
        this.countryCode === 'US'
          ? environment.symbol[0]
          : environment.symbol[1];

      this.formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
      });
      if (this.paymode === 'self') {
        this.homeInsurance = 'self';
        this.homeInsuranceName = 'self';
        this.homeInsuranceType = '';
        this.disabledInsType = true;
        this.homeInsuranceTypeName = '';
      } else {
        this.homeInsurance = this.scheduledData.insuranceId;
        this.homeInsuranceType = this.scheduledData.inType;
        this.homeInsuranceName = this.scheduledData.homeInsuranceName;
        this.homeInsuranceTypeName =
          this.scheduledData.inType === 2 ? 'HMO' : 'PPO';
        this.disabledInsType = false;
      }
      this.lat = this.scheduledData.latitude;
      this.lng = this.scheduledData.longitude;
      this.selectProcedureList = this.scheduledData.selectProcedureList;
      if (this.selectProcedureList && this.selectProcedureList.length >= 5) {
        this.showAddProcedureFormMob = false;
      } else {
        this.showAddProcedureFormMob = true;
      }
      if (this.selectProcedureList && this.selectProcedureList.length > 1) {
        this.multiplePro = true;
      }
      if (
        this.countryCode &&
        this.countryCode !== null &&
        this.countryCode === 'IN'
      ) {
        this.countryId = 101;
        this.placeholerCptCode = 'Procedure Name';
      }
      if (
        this.countryCode &&
        this.countryCode !== null &&
        this.countryCode === 'US'
      ) {
        this.countryId = 231;
        this.placeholerCptCode = 'Procedure Name';
      }
      this.getallinsurancebycountry();
    }
  }

  openInsuranceModal() {
    this.openModal(this.insuranceModal);
  }

  openInsuranceTypeModal() {
    this.openModal(this.insuranceTypeModal);
  }

  editProcedureNew() {
    this.editProcedure = true;
  }

  formatHomeDateStr(date) {
    const datearray = date.toString().split('-');
    if (datearray.length > 0) {
      const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];

      let day = datearray[2];
      if (day && day.length < 1) {
        day = '0' + day;
      }
      const monthIndex = +datearray[1];
      const year = datearray[0];

      return monthNames[monthIndex - 1] + ' ' + day + ',' + year;
    }
    return null;
  }

  formatHomeDate(date) {
    return this.homeSelectionShared.formatHomeDate(date);
  }

  getLanguage() {
    return this.homeSelectionShared.getLanguage(this);
  }

  onDateChanged(event) {
    this.showErrDate = false;
    if (event && event.formatted) {
      if (!(this.homeDate === event.formatted)) {
        this.homeDate = event.formatted;
        if (this.isMobile) {
          this.viewMobProcedures();
        }
      }
    }
  }

  onCalendarToggle(event: number) {
    // console.log('onCalendarToggle(): Reason: ', event);
  }

  onToggleCalendar(event: any): void {
    return this.homeSelectionShared.onToggleCalendar(this, event);
  }
  onToggleCalendar1(event: any): void {
    return this.homeSelectionShared.onToggleCalendar1(this, event);
  }

  getOffsetZone(latitude, longitude, type) {
    return this.homeSelectionShared.getOffsetZone(this, latitude, longitude, type);
  }

  onChangeAddress(address) {

    if (+this.lat !== +address.geometry.location.lat() && +this.lng !== +address.geometry.location.lng() && this.isMobile) {
      this.viewMobProcedures();
    }

    this.lat = address.geometry.location.lat();
    this.lng = address.geometry.location.lng();

    if (address && address['address_components']) {
      this.homeLocation = address.adr_address.split('<').map((s: string) => s.includes('>') ? s.slice(s.indexOf('>') + 1) : s).join('');

      for (
        let index = 0;
        index < address['address_components'].length;
        index++
      ) {
        if (address['address_components'][index]['types'][0] === 'country') {
          if (
            address['address_components'][index]['long_name'] === 'India' &&
            address['address_components'][index]['short_name'] === 'IN'
          ) {
            if (
              this.countryCode !==
              address['address_components'][index]['short_name']
            ) {
              this.countryCode = 'IN';
              this.getOffsetZone(this.lat, this.lng, 101);
              this.supportService.countryCode.next('IN');
              this.homeInsuranceType = 2;
              this.currencysymbol = environment.symbol[1];
              this.countryId = 101;
              this.homeInsurance = '';
              this.homeInsuranceName = '';
              this.homeInsuranceType = '';
              this.placeholerCptCode = 'Procedure Name';
              this.getallinsurancebycountry();
              if (!this.homeInsuranceName && this.isMobile) {
                this.openInsuranceModal();
              }
            }
          } else {
            if (
              this.countryCode !==
              address['address_components'][index]['short_name']
            ) {
              this.countryCode = 'US';
              this.getOffsetZone(this.lat, this.lng, 231);
              this.supportService.countryCode.next('US');
              this.homeInsurance = '';
              this.currencysymbol = environment.symbol[0];
              this.homeInsuranceType = '';
              this.homeInsuranceName = '';
              this.countryId = 231;
              this.placeholerCptCode = 'Procedure Name';
              this.getallinsurancebycountry();
              if (!this.homeInsuranceName && this.isMobile) {
                this.openInsuranceModal();
              }
            }
          }
        }
      }

      this.homeLocation = '';
      address['address_components'].forEach((obj) => {
        obj.types.forEach((childObj) => {
          if (this.countryCode === 'IN') {
            if (childObj === 'sublocality_level_1') {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === 'administrative_area_level_2' &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ', ' + obj.long_name;
            }
            if (
              childObj === 'administrative_area_level_2' &&
              this.homeLocation === ''
            ) {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === 'administrative_area_level_1' &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ', ' + obj.short_name;
            }
            if (
              childObj === 'administrative_area_level_1' &&
              this.homeLocation === ''
            ) {
              this.homeLocation = obj.short_name;
            }
          } else {
            if (childObj === 'locality') {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === 'administrative_area_level_1' &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ', ' + obj.short_name;
            }
            if (
              childObj === 'administrative_area_level_1' &&
              this.homeLocation === ''
            ) {
              this.homeLocation = obj.short_name;
            }
          }
        });
      });
      this.homeLocationPlaceholder = 'Location';
    }
  }

  selectInsuranceValue(insurance) {
    if (insurance === 'self') {
      this.homeInsurance = 'self';
      this.homeInsuranceName = 'Self Pay';
      this.homeInsuranceTypeName = '';
    } else {
      this.homeInsurance = insurance.id;
      this.homeInsuranceName = insurance.name;
    }
    this.modalRef.hide();
    this.viewMobProcedures();
    this.changeHomeInsurance(insurance);
  }

  selectInsuranceTypeValue(type, name) {
    this.homeInsuranceType = type;
    this.homeInsuranceTypeName = name;
    this.viewMobProcedures();
    this.modalRef.hide();
  }

  validate(schedDate) {
    return this.homeSelectionShared.validate(this, schedDate);
  }

  changeHomeInsurance(ins) {
    if (ins === 'self') {
      this.disabledInsType = true;
      this.homeInsuranceType = '';
      this.paymode = 'self';
    } else {
      this.disabledInsType = false;
      this.paymode = 'insurance';
      if (this.countryCode === 'IN') {
        this.homeInsuranceType = 2;
      }
    }
    if (
      this.countryCode !== 'IN' &&
      this.homeInsurance !== 'self' &&
      !this.homeInsuranceType &&
      this.isMobile
    ) {
      this.openInsuranceTypeModal();
    }
  }

  getallexams() {
    this.appservice.getAllExams().subscribe(
      (res) => {
        if (res && res['entity']) {
          this.allExamList = res['entity'];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallinsurancebycountry() {
    const data = {
      countryId: this.countryId,
    };

    this.appservice.getallinsurancebycountry(data).subscribe(
      (res) => {
        if (
          res &&
          res['status'] &&
          res['status']['status'] &&
          res['status']['status'] === 200
        ) {
          this.insuranceList = res['entity'];
        }
      },

      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: 'popup-center selectioncnf-popup' })
    );
  }

  confirmationPopAfterSave(testcenter, timeslot) {
    if (timeslot.procedureInputs[0] && !timeslot.procedureInputs[0].disabled) {
      this.testcenter = testcenter;
      this.timeslot = timeslot;
      this.timeSlotDisabeld = true;
      if (
        this.timeslot.procedureInputs &&
        this.timeslot.procedureInputs.length > 0
      ) {
        this.scheduleToTime = this.timeslot.procedureInputs[
          this.timeslot.procedureInputs.length - 1
        ].endTime;
      }
      this.triggerPopup();
    }
  }

  getallbodypartsbyhomeexamid() {
    const data = {
      examId: this.homeExamId,
    };
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          this.bodypartsList = res['entity'];
          if (this.allExamList && this.allExamList.length > 0) {
            for (let i = 0; i < this.allExamList.length; i++) {
              if (this.allExamList[i].id === this.homeExamId) {
                this.homeExamName = this.allExamList[i].examshortname;
                break;
              }
            }
          }
          this.homeBodyPartId = '';
          this.homeBodyPartName = '';
          this.homeProcedureName = '';
          this.homeCptCode = '';
          this.procedureList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallproceduresbyhomebodypart(bodypartId) {
    const data = {
      bodypartId: bodypartId,
    };
    if (this.bodypartsList && this.bodypartsList.length > 0) {
      for (let i = 0; i < this.bodypartsList.length; i++) {
        if (this.bodypartsList[i].id === this.homeBodyPartId) {
          this.homeBodyPartName = this.bodypartsList[i].bodyPart;
          break;
        }
      }
    }
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        this.homeProcedureName = '';
        this.homeCptCode = '';
        if (res && res['entity'] && res['entity'].length > 0) {
          for (let e = 0; e < res['entity'].length; e++) {
            res['entity'][e].checked = false;
          }
          this.procedureList = [];
          this.procedureList = res['entity'];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  checkInCC() {
    if (this.countryCode === 'IN') {
      return true;
    }
    return false;
  }
  checkUSIndex24(i) {
    if (this.countryCode !== 'IN') {
      if (i === 0 || i === 2 || i === 4) {
        return true;
      }
    }
    return false;
  }

  checkUSIndex13(i) {
    if (this.countryCode !== 'IN') {
      if (i === 1 || i === 3) {
        return true;
      }
    }
    return false;
  }

  openExamModal() {
    this.openModal(this.examModal);
  }

  cptcodeChangeForMobile(value) {
    if (value && value.toString().length === 5) {
      let isExist = false;
      if (this.selectProcedureList && this.selectProcedureList.length > 0) {
        for (let s = 0; s < this.selectProcedureList.length; s++) {
          if (this.selectProcedureList[s].cptCode === value) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          this.getallExamListOnchangeForMobile(value);
        } else {
          this.toastr.error('Procedure already selected');
          this.blockAddMultipleProcedure = true;
          this.homeProcedureName = '';
          this.homeCptCode = '';
          this.addProcedureList.bodyPartId = '';
          this.homeBodyPartName = '';
          this.addProcedureList.examId = '';
          this.homeExamName = '';
        }
      }
    }
  }

  getallExamListOnchangeForMobile(cptcode) {
    const data = { cptcode: cptcode };
    this.appservice
      .getallexamdandprocedureandbodypartbycptcodeForhome(data)
      .subscribe((res) => {
        if (res && res['status']['status'] === 200) {
          if (
            res &&
            res['entity'] &&
            res['entity']['bodyPart'] &&
            res['entity']['bodyPart']['exam']
          ) {
            this.cptcodeobjectForMobile = res['entity'];
            this.addProcedureList.examId =
              res['entity']['bodyPart']['exam']['id'];
            this.homeExamName =
              res['entity']['bodyPart']['exam']['examshortname'];
            this.addProcedureList.examName =
              res['entity']['bodyPart']['exam']['examshortname'];

            this.getallbodypartsbyexamonchangeForMobile(
              res['entity']['bodyPart']['exam']['id']
            );
          }
        } else if (res['status']['status'] === 204) {
          this.toastr.error('Please check your cptcode');
          this.blockAddMultipleProcedure = true;
          this.homeProcedureName = '';
          this.homeCptCode = '';
          this.addProcedureList.bodyPartId = '';
          this.homeBodyPartName = '';
          this.addProcedureList.examId = '';
          this.homeExamName = '';
        }
      });
  }

  getallbodypartsbyexamonchangeForMobile(examid) {
    const data = { examId: examid };
    this.appservice.getallbodypartsbyexamid(data).subscribe((res) => {
      if (res && res['status'] && res['status']['status'] === 204) {
        this.toastr.error('bodypart is not available');
        this.addProcedureList.bodyPartId = '';
        this.homeBodyPartName = '';
      } else if (res && res['entity']) {
        this.addProcedureList.bodyPartList = res['entity'];
        this.addProcedureList.procedureList = [];
        this.addProcedureList.bodyPartId = this.cptcodeobjectForMobile[
          'bodyPart'
        ]['id'];
        this.homeBodyPartName = this.cptcodeobjectForMobile['bodyPart'][
          'bodyPart'
        ];
        this.addProcedureList.bodyPartName = this.cptcodeobjectForMobile[
          'bodyPart'
        ]['bodyPart'];
        this.homeCptCode = this.cptcodeobjectForMobile['cptCode'];
        this.getallproceduresbybodypartbyonchangeForMobile(
          this.addProcedureList.bodyPartId
        );
      }
    });
  }

  getallproceduresbybodypartbyonchangeForMobile(bodypartId) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          this.addProcedureList.procedureList = res['entity'];
          for (let i = 0; i < res['entity'].length; i++) {
            if (res['entity'][i].id === this.cptcodeobjectForMobile['id']) {
              this.addProcedureList.procedureSelected = res['entity'][i];
              this.homeProcedureName = res['entity'][i].procedureName;
              this.blockAddMultipleProcedure = false;
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  selectExamValue(exam) {
    this.modalRef.hide();
    this.addProcedureList.examId = exam.id;
    this.homeExamName = exam.examshortname;
    this.addProcedureList.bodyPartList = [];
    this.addProcedureList.bodyPartId = '';
    this.homeBodyPartName = '';
    this.getallbodypartsbyexamidNew(exam.id, 0);
    if (this.isMobile) {
      this.openpopup();
    }
  }

  openBodyPartModal() {
    this.openModal(this.bodyPartModal);
  }

  selectBodyPartValue(bodyPart) {
    this.modalRef.hide();
    this.addProcedureList.bodyPartId = bodyPart.id;
    this.homeBodyPartName = bodyPart.bodyPart;
    this.homeProcedureName = '';
    this.getallproceduresbybodypartNew(bodyPart.id, 0);
    if (this.isMobile) {
      this.openpopup();
    }
  }

  openProcedureModal() {
    this.openModal(this.ProcedureModal);
  }

  getallbodypartsbyexamidNew(examid, index) {
    const data = {
      examId: examid,
    };
    this.addProcedureList.examId = examid;
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          this.addProcedureList.bodyPartList = res['entity'];
          this.addProcedureList.bodyPartId = '';
          this.addProcedureList.procedureList = [];
          if (this.allExamList && this.allExamList.length > 0) {
            for (let i = 0; i < this.allExamList.length; i++) {
              if (this.allExamList[i].id === this.addProcedureList.examId) {
                this.addProcedureList.examName = this.allExamList[
                  i
                ].examshortname;
                break;
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallbodypartsbyexamid(examid, index) {
    const data = {
      examId: examid,
    };
    this.selectProcedureList[index].examId = examid;
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          this.selectProcedureList[index].bodyPartList = res['entity'];
          if (this.allExamList && this.allExamList.length > 0) {
            for (let i = 0; i < this.allExamList.length; i++) {
              if (
                this.allExamList[i].id === this.selectProcedureList[index].examId
              ) {
                this.selectProcedureList[index].examName = this.allExamList[
                  i
                ].examshortname;
                break;
              }
            }
          }
          this.selectProcedureList[index].bodyPartId = '';
          this.selectProcedureList[index].bodyPartName = '';
          this.selectProcedureList[index].cptCode = '';
          this.selectProcedureList[index].procedureName = '';
          this.selectProcedureList[index].procedureList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallproceduresbybodypartNew(bodypartId, index) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          this.addProcedureList.procedureList = res['entity'];
          if (
            this.addProcedureList.bodyPartList &&
            this.addProcedureList.bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.addProcedureList.bodyPartList.length;
              i++
            ) {
              if (this.addProcedureList.bodyPartList[i].id === bodypartId) {
                this.addProcedureList.bodyPartName = this.addProcedureList.bodyPartList[
                  i
                ].bodyPart;
                break;
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallproceduresbybodypart(bodypartId, index) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res['entity']) {
          for (let e = 0; e < res['entity'].length; e++) {
            res['entity'][e].checked = false;
          }
          this.selectProcedureList[index].cptCode = '';
          this.selectProcedureList[index].procedureName = '';
          this.selectProcedureList[index].procedureList = res['entity'];
          if (
            this.selectProcedureList[index].bodyPartList &&
            this.selectProcedureList[index].bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].bodyPartList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].bodyPartList[i].id === bodypartId
              ) {
                this.selectProcedureList[
                  index
                ].bodyPartName = this.selectProcedureList[index].bodyPartList[
                  i
                ].bodyPart;
                this.selectProcedureList[index].open = true;
                this.openpopuptemplate(
                  this.selectProcedureList[index].procedureList,
                  index
                );
                break;
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  removeSelectProcedureListMob(index) {
    return this.homeSelectionShared.removeSelectProcedureListMob(this, index);
  }

  removeSelectProcedureList(index) {
    if (index === 0) {
      this.selectProcedureList = [
        {
          examId: '',
          bodyPartList: [],
          bodyPartId: '',
          procedureList: [],
          cptCode: '',
          procedureName: '',
        },
      ];
    } else {
      this.selectProcedureList.splice(index, 1);
    }
    if (this.selectProcedureList && this.selectProcedureList.length === 1) {
      this.multiplePro = false;
    }
  }

  addSelectProcedureList() {
    return this.homeSelectionShared.addSelectProcedureList(this);
  }

  openpopuptemplate(procedures, ind) {
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (s !== ind) {
          this.selectProcedureList[s].open = false;
        }
      }
    }
    this.selectIndex = ind;
    if (procedures && procedures.length > 0) {
      this.popProcedures = procedures;
    } else {
      this.popProcedures = [{ id: '', cptCode: '', procedureName: '' }];
    }
  }

  selectMultipleProcedure() {
    return this.homeSelectionShared.selectMultipleProcedure(this);
  }

  navigatePatientProfileform() {
    this.pushScheduledData();
  }

  private isProcedureAlreadySelected(procedure) {
    let isExist = false;
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (this.selectProcedureList[s].cptCode === procedure.cptCode) {
          isExist = true;
          break;
        }
      }
    }
    return isExist;
  }

  changeHomeCptCode(procedure) {
    const isExist = this.isProcedureAlreadySelected(procedure);
    if (!isExist) {
      this.homeCptCode = procedure.cptCode;
      this.homeProcedureName = procedure.procedureName;
      if (
        this.selectProcedureList &&
        this.selectProcedureList.length === 1 &&
        !this.selectProcedureList[0].examId
      ) {
        this.selectProcedureList = [];
      }
      this.selectProcedureList.push({
        examId: this.homeExamId,
        examName: this.homeExamName,
        bodyPartId: this.homeBodyPartId,
        bodyPartName: this.homeBodyPartName,
        cptCode: this.homeCptCode,
        procedureName: this.homeProcedureName,
        close: false,
      });
      this.homeExamId = '';
      this.homeBodyPartId = '';
      this.bodypartsList = [];
      this.homeCptCode = '';
      this.homeExamName = '';
      this.homeBodyPartName = '';
      this.homeProcedureName = '';
      this.procedureList = [];
    } else {
      this.toastr.error('Procedure already selected');
    }
  }

  changeCptCode(value, spInd, ind, procedure) {
    const isExist = this.isProcedureAlreadySelected(procedure);
    if (!isExist) {
      this.selectProcedureList[spInd].procedureList[ind].checked = value;
      this.selectProcedureList[spInd].cptCode = procedure.cptCode;
      this.selectProcedureList[spInd].procedureName = procedure.procedureName;
      this.selectProcedureList[spInd].open = false;
    } else {
      this.toastr.error('Procedure already selected');
    }
  }

  private isProcedureSelectionValid() {
    return this.homeSelectionShared.isProcedureSelectionValid(this);
  }

  scheduleFormSubmit(type) {
    if (this.selectProcedureList.length > 0) {
      let valid = true;
      this.timeSlotDisabeld = false;
      this.homeinfosubmit = true;
      if (this.countryCode === 'IN') {
        if (!this.homeInsurance) {
          this.toastr.error('Please fill Insurance');
          return;
        }
        this.currencysymbol = environment.symbol[1];
        valid = this.isProcedureSelectionValid();
      }

      if (this.countryCode === 'US') {
        if (!this.homeInsurance) {
          this.toastr.error('Please fill Insurance');
          return;
        }
        if (!this.homeInsuranceType && this.homeInsurance !== 'self') {
          this.toastr.error('Please fill Insurance type');
          return;
        }
        this.currencysymbol = environment.symbol[0];
        valid = this.isProcedureSelectionValid();
      }

      if (valid) {
        if (this.homeInsuranceType === '') {
          this.homeInsuranceType = '2';
        }
        if (type !== 'final') {
          this.selectMultipleProcedure();
        } else if (type === 'final') {
          this.navigatePatientProfileform();
        }
      } else {
        this.toastr.error('Please fill all the fields.');
      }
    } else {
      this.toastr.error('Please add atleast one Exam.');
    }
  }

  findDay(day) {
    if (day === 0) {
      this.dayOfweek = 'Sunday';
    }
    if (day === 1) {
      this.dayOfweek = 'Monday';
    }
    if (day === 2) {
      this.dayOfweek = 'Tuesday';
    }
    if (day === 3) {
      this.dayOfweek = 'Wednesday';
    }
    if (day === 4) {
      this.dayOfweek = 'Thursday';
    }
    if (day === 5) {
      this.dayOfweek = 'Friday';
    }
    if (day === 6) {
      this.dayOfweek = 'saturday';
    }
  }

  findpaymode() {
    return this.homeSelectionShared.findpaymode(this);
  }

  setAllProcedureValueNew(procedure) {
    const isExist = this.isProcedureAlreadySelected(procedure);
    if (!isExist) {
      this.addProcedureList.procedureSelected = procedure;
      this.homeProcedureName = procedure.procedureName;
      this.homeCptCode = procedure.cptCode;
      this.blockAddMultipleProcedure = false;
      this.modalRef.hide();
    } else {
      this.blockAddMultipleProcedure = true;
      this.homeProcedureName = '';
      this.homeCptCode = '';
      this.toastr.error('Procedure already selected');
    }
  }

  addNewProcedureList(list) {
    this.homeinfosubmitNew = true;
    if (list && list.examId && list.bodyPartId && list.procedureSelected) {
      this.selectProcedureList.push({
        examId: list.examId,
        bodyPartList: list.bodyPartList,
        bodyPartId: list.bodyPartId,
        procedureList: list.procedureSelected,
        cptCode: list.procedureSelected.cptCode,
        bodyPartName: list.bodyPartName,
        examName: list.examName,
        procedureName: list.procedureSelected.procedureName,
        open: false,
      });
      this.homeProcedureName = '';
      this.homeCptCode = '';
      this.homeExamName = '';
      this.homeBodyPartName = '';
      this.homeinfosubmitNew = false;
      this.addProcedureList.examId = '';
      this.addProcedureList.bodyPartId = '';
      this.addProcedureList.bodyPartName = '';
      this.addProcedureList.cptCode = '';
      this.addProcedureList.procedureName = '';
      this.addProcedureList.procedureId = '';
      this.addProcedureList.procedureList = [];
      this.addProcedureList.procedureSelected = '';
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      if (this.selectProcedureList.length >= 5) {
        this.showAddProcedureFormMob = false;
      } else {
        this.showAddProcedureFormMob = true;
      }
    } else {
      this.toastr.error('Please fill the all fields');
    }
  }

  scrollTop(value) {
    if (value === 'top-screen-mobile') {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    } else {
      document.getElementById(value).scrollIntoView({ behavior: 'smooth' });
    }
  }

  openpopup() {
    setTimeout(() => {
      if (this.isMobile) {
        if (!this.homeBodyPartName) {
          this.openBodyPartModal();
        } else if (!this.homeProcedureName) {
          this.openProcedureModal();
        }
      }
    }, 100);
  }

  viewMobProcedures() {
    this.viewMobProceduresList = true;
    this.showFilters = false;
  }

  hideMobProcedures() {
    this.viewMobProceduresList = false;
    this.showFilters = false;
  }

  getRoundedDate = (minutes, d = new Date()) => {
    return this.homeSelectionShared.getRoundedDate(minutes, d);
  };

  pushScheduledData() {
    const day = new Date(this.homeDate).getDay();
    const scheduleOn = this.datePipe.transform(this.homeDate, 'yyyy-MM-dd');
    const now = new Date();
    console.log("zonedata");
    console.log(now.getTimezoneOffset());

    const zoneDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    console.log(zoneDate);
    console.log(this.timeZone);
    console.log(this.scheduledData.offsetmin);

    zoneDate.setMinutes(
      zoneDate.getMinutes() +
      (this.timeZone ? +this.timeZone : +this.scheduledData.offsetmin) +
      15
    );
    const roundedDate = this.getRoundedDate(15, zoneDate);
    roundedDate.setSeconds(0);

    console.log(roundedDate);

    this.findDay(day);
    this.findpaymode();
    this.cptCodeList = [];
    if (
      this.homeDate &&
      this.homeLocation &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        }
      }

      this.scheduledData = {
        scheduleId: this.scheduledData.scheduleappointmentid,
        scheduleOn: scheduleOn,
        scheduleOnStr: scheduleOn,
        dayOfweek: this.dayOfweek,
        location: this.homeLocation,
        insuranceId:
          this.homeInsurance && this.homeInsurance !== 'self'
            ? this.homeInsurance
            : 0,
        inType:
          this.homeInsuranceType && this.homeInsuranceType !== ''
            ? this.homeInsuranceType
            : 0,
        selectProcedureList: this.selectProcedureList,
        cptCodeList: this.cptCodeList,
        payMode: this.paymode,
        countryCode: this.countryCode,
        latitude: this.lat,
        longitude: this.lng,
        selectedExam: '',
        selectedExamId: '',
        today: this.datePipe.transform(roundedDate, 'yyyy-MM-dd'),
        timeZone: '',
        offsetmin: this.timeZone ? +this.timeZone : +this.scheduledData.offsetmin,
        currentTime: this.datePipe.transform(roundedDate, 'hh:mm aa'),
        homeInsuranceName: this.scheduledData.homeInsuranceName
          ? this.scheduledData.homeInsuranceName
          : '',
      };

      sessionStorage.setItem(
        'scheduleData',
        JSON.stringify(this.scheduledData)
      );

      this.gettestcentersbycriteria();
    }
  }

  redirectToScheduleForm() {
    this.router.navigate(['/schedule-form']);
  }

  redirectToLocation() {
    return this.homeSelectionShared.redirectToLocation(this);
  }

  convetTimeZoneOffsetToTime() {
    return this.homeSelectionShared.convetTimeZoneOffsetToTime(this);
  }

  gettestcentersbycriteria() {
    this.ngxloader.start();
    if (this.scheduledData) {
      const data = {
        scheduleOn: this.scheduledData.scheduleOn,
        scheduleOnStr: this.scheduledData.scheduleOnStr,
        location: this.scheduledData.location,
        dayOfweek: this.scheduledData.dayOfweek,
        payMode: this.scheduledData.payMode,
        insurance: this.scheduledData.insuranceId,
        inType: this.scheduledData.inType,
        cptCodes: this.scheduledData.cptCodeList,
        latitude: this.scheduledData.latitude,
        longitude: this.scheduledData.longitude,
        today: this.scheduledData.today,
        timeZone: '',
        currentTime: this.scheduledData.currentTime,
      };

      this.appservice.gettestcentersbycriteria(data).subscribe((res) => {
        this.scheduleRegion = [];
        this.testcentrebycriteria = [];
        this.areas = [];
        this.ngxloader.stop();
        this.hideMobProcedures();
        if (res && res['entity']) {
          this.scheduleRegion = res['entity'];
          if (this.scheduleRegion && this.scheduleRegion.schedules) {
            this.testcentrebycriteria = this.scheduleRegion.schedules;
            this.checkDate();
          }
          if (
            this.scheduleRegion.areas &&
            this.scheduleRegion.areas.length > 0
          ) {
            this.areas = [];
            for (let i = 0; i < this.scheduleRegion.areas.length; i++) {
              this.areas.push({
                areaName: this.scheduleRegion.areas[i],
                checked: true,
              });
            }
          }
        }
      }, err => {
        this.ngxloader.stop();
      });
    }
  }

  checkDate() {
    if (this.testcentrebycriteria && this.testcentrebycriteria.length > 0) {
      for (let i = 0; i < this.testcentrebycriteria.length; i++) {
        this.testcentrebycriteria[i].disabledMsg = true;
        if (
          this.testcentrebycriteria[i].schedules &&
          this.testcentrebycriteria[i].schedules.length > 0
        ) {
          for (
            let j = 0;
            j < this.testcentrebycriteria[i].schedules.length;
            j++
          ) {
            this.testcentrebycriteria[i].disabledMsg = false;
          }
        }
      }
    }
  }

  triggerPopup() {
    this.scheduleappointment();
  }

  scheduleappointment() {
    let patientType = 'Sched';
    if (this.desktopView && !this.mobileView) {
      patientType = 'Sched';
    } else if (!this.desktopView && this.mobileView) {
      patientType = 'Mobile';
    }

    const schedInsuranceInput = [];
    schedInsuranceInput.push({
      insurance: {
        id:
          this.homeInsurance && this.homeInsurance !== 'self'
            ? this.homeInsurance
            : 0,
      },
      insuranceType: { id: this.homeInsuranceType },
    });

    const data = {
      scheduleId: this.scheduleappointmentid,
      scheduledOn: this.datePipe.transform(this.homeDate, 'yyyy-MM-dd'),
      scheduledOnStr: this.datePipe.transform(this.homeDate, 'yyyy-MM-dd'),
      choosenLocation: this.homeLocation,
      latitude: this.lat,
      longitude: this.lng,
      payMode: this.paymode,
      schedInsuranceInput:
        schedInsuranceInput && schedInsuranceInput.length > 0
          ? schedInsuranceInput
          : null,
      patient: {
        id: this.patientData.id,
        firstName: this.patientData.firstName,
        lastName: this.patientData.lastName,
        patientEmail: this.patientData.patientEmail,
        patientPhone: this.patientData.patientPhone,
        patientPhoneCode: this.patientData.patientPhoneCode,
        gender: this.patientData.gender,
      },
      procedureInputs: this.timeslot.procedureInputs,
      preAuthorized:
        this.countryId === 'IN' && this.paymode === 'insurance' ? true : false,
      scheduleFromTime: this.timeslot.procedureInputs[0].startTime,
      scheduleToTime: this.scheduleToTime,
      timeZone: this.getOffsetZone(this.lat, this.lng, this.countryCode === 'IN' ? 101 : 231),
      totalAmount: this.testcenter.totalAmount,
      schedMed: true,
      schedStatusId: 1,
      testCenterId: this.testcenter.testcenterId,
      patientType: patientType,
    };
    if (
      this.countryCode === 'IN' ||
      (this.countryCode === 'US' && this.paymode === 'self')
    ) {
      this.ngxloader.start();
      this.appservice.scheduleappointment(data).subscribe(
        (res) => {
          this.ngxloader.stop();
          this.timeSlotDisabeld = false;
          if (res && res['status'] && res['status']['status'] === 200) {
            sessionStorage.setItem('scheduleData', null);
            sessionStorage.setItem('patientData', null);
            this.router.navigate(['/patient-profile', res['entity'].id]);
          }
        },
        (err) => {
          this.ngxloader.stop();
          this.timeSlotDisabeld = false;
          this.toastr.error(err.error.status.msg);
        }
      );
    } else {
      sessionStorage.setItem('appointData', JSON.stringify(data));
      sessionStorage.setItem('scheduleData', null);
      sessionStorage.setItem('patientData', null);
      if (this.isMobile) {
        document.getElementById('mobile-preauth').click();
      } else {
        this.openModal(this.confirmationpopup);
        const ele = document.querySelectorAll('.popup-center');
      }
    }
  }

  scheduleappointmentPopup(type) {
    if (!this.isMobile) {
      this.modalRef.hide();
    } else {
      document.getElementById('close-modal1').click();
    }

    sessionStorage.getItem('appointData') !== null
      ? (this.appointData = JSON.parse(sessionStorage.getItem('appointData')))
      : (this.appointData = {});
    if (!this.appointData) {
      this.router.navigate(['/home']);
    }
    const data = this.appointData;
    if (type === 'yes') {
      data.preAuthorized = true;
    } else {
      data.preAuthorized = false;
    }
    let patientType = 'Sched';
    if (this.desktopView && !this.mobileView) {
      patientType = 'Sched';
    } else if (!this.desktopView && this.mobileView) {
      patientType = 'Mobile';
    }

    data['patientType'] = patientType;

    this.appservice.scheduleappointment(data).subscribe(
      (res) => {
        if (res && res['status'] && res['status']['status'] === 200) {
          sessionStorage.setItem('appointData', null);
          if (type === 'yes') {
            this.router.navigate(['/patient-profile', res['entity'].id]);
          } else {
            this.router.navigate(['/pre-autho2', res['entity'].id]);
          }
        }
      },
      (err) => {
        this.toastr.error(err.error.status.msg);
      }
    );
  }

  handleAddressChange(evt) { }

  addFilterAreas(i) {
    this.filteron = false;
    if (this.areas && this.areas.length > 0) {
      for (let n = 0; n < this.areas.length; n++) {
        if (this.areas[n].checked) {
          this.filteron = true;
          break;
        }
      }
    }
  }

  checkAreaFilter(tc) {
    if (tc && this.areas && this.areas.length > 0) {
      let exist = false;
      for (let i = 0; i < this.areas.length; i++) {
        let tcAreaName = '';
        let tcAreaName1 = '';
        tcAreaName = tc.tcView.areaName.trim();
        tcAreaName1 = this.areas[i].areaName.trim();
        if (
          this.areas[i].checked &&
          tcAreaName.toLowerCase() === tcAreaName1.toLowerCase()
        ) {
          exist = true;
          break;
        }
      }
      return exist;
    } else {
      return true;
    }
  }

  getSelectProcedureSize() {
    if (this.selectProcedureList && this.selectProcedureList.length === 1) {
      return 150;
    } else if (
      this.selectProcedureList &&
      this.selectProcedureList.length === 2
    ) {
      return 230;
    } else {
      return 300;
    }
  }
}
